import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'url-search-params-polyfill'
import 'date-time-format-timezone'

import 'stylesheets/normalize.css'

import React from 'react'
import { createRoot } from 'react-dom/client'

import { datadogLogs } from '@datadog/browser-logs'

import App from 'components/App'

// ProTip: Set DATADOG_ENVIRONMENT to 'development:username' in your
// .env.local to make development easier
const env = process.env.DATADOG_ENVIRONMENT

datadogLogs.init({
  clientToken: 'pub1c09a91535f5ba2fa778c377d464f452',
  env,
  forwardErrorsToLogs: false,
  service: 'dashboard',
  sessionSampleRate: 100,
  site: 'datadoghq.com',
})

createRoot(document.getElementById('app')).render(<App />)
